// Generated by ReScript, PLEASE EDIT WITH CARE


function makeTrophyState(trophies) {
  if (trophies.length === 0) {
    return "TrophiesNotBuilt";
  } else {
    return {
            TAG: "TrophiesReady",
            _0: trophies
          };
  }
}

var PlayerEquippedFragment;

export {
  PlayerEquippedFragment ,
  makeTrophyState ,
}
/* No side effect */
